import {mutationRequest} from "./makePostRequest";

export const mutationRegisterUser = (body) => mutationRequest('registerUser', `registerUser`, body);
// export const mutationRegisterUser = (body) => mutationRequest('registerUser', `registerUser?email=${body?.email}&password=${body?.password}&locality=${body?.locality}&name=${body?.name}`, body);

export default mutationRegisterUser;
